// import InputData from '@/view/certification/InputData.vue'
// import InputDataFulfill from '@/view/certification/InputDataFulfill.vue'
// import Fulfill from '@/view/certification/Fulfill.vue'
// import UploadDocuments from '@/view/certification/UploadDocuments.vue'
// import UploadDocumentsIndividual from '@/view/certification/UploadDocumentsIndividual.vue'

const routes = [
  {
    path: '/certification/inputData',
    name: 'inputData',
    component: () => import('@/view/certification/InputData.vue')
  },
  {
    path: '/certification/uploadDocuments',
    name: 'uploadDocuments',
    component: () => import('@/view/certification/UploadDocuments.vue')
  },
  {
    path: '/certification/uploadDocumentsIndividual',
    name: 'uploadDocumentsIndividual',
    component: () => import('@/view/certification/UploadDocumentsIndividual.vue')
  },
  {
    path: '/certification/inputDataFulfill',
    name: 'inputDataFulfill',
    component: () => import('@/view/certification/InputDataFulfill.vue')
  },
  {
    path: '/certification/fulfill',
    name: 'fulfill',
    component: () => import('@/view/certification/Fulfill.vue')
  },
]

export default { routes }